import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {FormsModule} from "@angular/forms";
import {BillData} from "../../../shipper";


@Component({
	selector: 'isf-containers-pastein',
	standalone: true,
	imports: [
		FormsModule
	],
	template: `

        <div>
            <textarea id="isfBillContainers" [(ngModel)]="txtIn" cols="30" rows="5" placeholder="Paste container numbers for {{bill.billNumber}} here, 1 per line"
                      class="form-control form-control-plaintext bg-body-secondary"></textarea>
            <div>
				<div class="row">
					<div class="col-6">
                        <button class="btn btn-lg btn-primary w-100" (click)="submit()">OK</button>
					</div>
					<div class="col-6">
                        <button class="btn btn-lg btn-danger w-100" (click)="clear()">X</button>
					</div>
				</div>
            </div>
        </div>
	`,
	styles:[`
	
	`]
})
export class IsfContainersPasteInForm implements OnInit{
	
	txtIn!:string;
	
	@Input()
	bill!:BillData;
	
	@Output()
	onSubmit:EventEmitter<string[]> = new EventEmitter();
	
	@Output()
	onClear:EventEmitter<void> = new EventEmitter();
	
	
	ngOnInit(): void {
		if(this.bill && this.bill.containers){
			this.txtIn = this.bill?.containers.map(c => c.containerNumber).join("\n");
		}
	}
	
	
	submit(){
	
		if(this.txtIn == null || this.txtIn == ""){return;}
		
		let bills:Array<string> = this.txtIn.split("\n")
			.map((bill) => bill.trim().toUpperCase().replace(/\W/g, ''));
		
		
		this.onSubmit.emit(bills);
	}
	
	
	clear(){
		this.txtIn = "";
		this.onClear.emit();
	}
}
